import { Button, Modal, TextButton } from '@zillow/constellation-10';

import PremiumOverviewModalContent from '../Modal/PremiumOverviewModal';

const RENDER_AS_TYPE = {
  BUTTON: 'Button',
  TEXT_BUTTON: 'TextButton',
};

const getButtonComponent = (as: string) => {
  if (as === RENDER_AS_TYPE.BUTTON) {
    return Button;
  }

  if (as === RENDER_AS_TYPE.TEXT_BUTTON) {
    return TextButton;
  }

  return Button; // default fallback
};

type LearnAboutPremiumButtonProps = {
  as: string;
  children: React.ReactNode;
};

const LearnAboutPremiumButton = ({ as = RENDER_AS_TYPE.BUTTON, children }: LearnAboutPremiumButtonProps) => {
  const ComponentButton = getButtonComponent(as);

  return (
    <Modal
      data-testid="PremiumOverviewModal"
      dividers={false}
      size={{
        base: 'fullScreen',
        lg: 'md',
      }}
      trigger={<ComponentButton data-test="LearnAboutPremiumButton">{children}</ComponentButton>}
      body={<PremiumOverviewModalContent />}
    />
  );
};

export { RENDER_AS_TYPE };

export default LearnAboutPremiumButton;
